<h2 mat-dialog-title>Processos Seletivos Arquivados</h2>
<mat-dialog-content>
    <form [formGroup]="form" (submit)="submit()" autocomplete="off">
        <ng-container *ngIf="process?.length > 0; else nullprocess">
            <span>Abaixo aparecerá os processos seletivos arquivados.</span>
            <div class="row" style="margin-top: 10px;">
                <mat-form-field appearance="outline">
                    <mat-label>Processos Seletivos</mat-label>
                    <mat-select formControlName="selectedProcesses" multiple>
                        <mat-option *ngFor="let listprocess of process" [value]="listprocess.id">
                            {{ listprocess.name }} - Cargo: {{ listprocess.sinonimo }} - Salário: {{ formatMoney(listprocess.salary)  }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('selectedProcesses').errors?.required">
                        Por favor, escolha pelo menos uma opção.
                    </mat-error>
                    <mat-hint>Selecione um ou mais processos para desarquivar</mat-hint>
                </mat-form-field>
            </div>
        </ng-container>
        <ng-template #nullprocess>
            <span>Abaixo aparecerá os processos seletivos arquivados.</span>
            <div class="empty-content" style="min-height: 210px;">
                <span class="mat-body-2">Nenhum processo seletivo arquivado</span>
            </div>
        </ng-template>    
    </form>
</mat-dialog-content>
<mat-progress-bar *ngIf="submitting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submitting">
    <ng-container *ngIf="process?.length > 0; else btnclose">
    <button color="accent" mat-button mat-dialog-close>Cancelar</button>
    <button
        class="custom-primary"
        color="primary"
        mat-raised-button
        type="submit"
        [disabled]="!form.valid"
        (click)="submit()"
    >
        Salvar
    </button>
    </ng-container>
    <ng-template #btnclose>
        <button color="accent" mat-button mat-dialog-close>Fechar</button>
    </ng-template>
</mat-dialog-actions>